'use client';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

datadogRum.init({
  applicationId: 'de8f4cca-cc94-4c84-8298-07d7dd130b95',
  clientToken: 'pub85affc9c515e6f8fe5253e1d424ee468',
  site: 'datadoghq.eu',
  service: 'www.normo.ai',
  env: process.env.NEXT_PUBLIC_DATADOG_ENV || 'development',
  // Specify a version number to identify the deployed version of your application in Datadog
  version: process.env.NEXT_PUBLIC_APP_VERSION || 'unknown',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 30,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  plugins: [reactPlugin({router: false})],
  // Specify URLs to propagate trace headers for connection between RUM and backend trace
  allowedTracingUrls: [
    {match: 'https://www.normo.ai', propagatorTypes: ['tracecontext']},
    {
      match: 'https://www.api.staging.normo.ai',
      propagatorTypes: ['tracecontext'],
    },
    {match: 'https://api.staging.normo.ai', propagatorTypes: ['tracecontext']},
    {match: 'https://staging.normo.ai', propagatorTypes: ['tracecontext']},
    {match: 'https://api.staging.normo.ai', propagatorTypes: ['tracecontext']},
    {match: 'https://api.normo.ai', propagatorTypes: ['tracecontext']},
    {match: 'http://localhost:5000', propagatorTypes: ['tracecontext']},
    {match: 'http://localhost:5001', propagatorTypes: ['tracecontext']},
  ],
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
